import {GameStateEnums} from '../../../../../shared/GameEnums'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {ActionsThatCanBeCancelled, BeginnerHintFormat, GameAction} from '@colonist/game-base-types'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameActionButtonView} from './UIGameActionButtonView'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {CA} from '../../analytics/Analytics'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameActionButtonPositions} from './UIGameActionsController'
import {UIGameBeginnerHintView} from '../ui_game_beginner_hints/UIGameBeginnerHintView'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {bringToFront} from '../../ui_utils/PixiUtils'
import {Sound} from '../../Sound'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {FloatingText} from '../../game_ui_view_objects/FloatingText'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TurnState} from '@colonist/game-states'

export class UIGameActionButtonViewTrade extends UIGameActionButtonView implements UIGameMechanic {
    constructor(uiGameManager: UIGameManager, container: PIXI.Container) {
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trade)
        super(uiGameManager, UIGameActionButtonPositions.Trade, container)
        this.addCenteredIcon(texture)
        this.repositionedButton = () => {
            const beginnerHintActive = this.beginnerHintView != undefined
            this.destroyBeginnerHintView()
            if(beginnerHintActive) this.beginnerHintReceived({type: GameAction.CreateTrade, data: {}})
        }

        this.setTip({key: 'strings:game.tooltips.trade'}, [{key: 'strings:colonistCommon.utils.emptyString'}])
        this.setUpdateAction()
        this.stateUpdated()
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CloseTradeUI:
                this.visible = true
                break
            case UIGameEventEnums.ShowTradeUI: this.onShowTradeUI(); break
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.GameStateUpdated: this.stateUpdated(); break
            case UIGameEventEnums.BeginnerHintReceived: this.beginnerHintReceived(data); break
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.BeginnerModeInteractWithGuide: this.onBeginnerModeInteractWithGuide(data, GameAction.CreateTrade); break
            default: break
        }
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.uiGameManager.tradeController.onClickTrade(this)
            this.uiGameManager.toolTipController.closeTip()

            if(!UIUtilsEjsVariables.isUserOnMobileApp) return
            CA.sendEventSummed(CA.Category.Game, CA.Label.ClickedGameTradeButton, UIGameEventEnums.GameEnd)
        })
    }

    private stateUpdated() {
        this.inactivateOpacity()
        if(!this.uiGameManager.gameController.isMyTurn) return
        if(this.uiGameManager.gameController.currentState.turnState != TurnState.Turn) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        if(this.isBeginnerMode && this.beginnerModeActionType != GameAction.CreateTrade) return
        this.activateOpacity()
    }

    private beginnerHintReceived(data: BeginnerHintFormat) {
        if(this.parent == undefined) return
        if(data.type != GameAction.CreateTrade) return
        if(!this.visible) return

        this.destroyBeginnerHintView()
        Sound.playSound(Sound.SoundType.BeginnerHintActivated)
        this.beginnerHintView = new UIGameBeginnerHintView(this.uiGameManager, this, {key: 'strings:game.beginnerTips.actionHints.description', options: {context: 'trade'}}, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trade))
        bringToFront(this.parent)
    }

    private onShowTradeUI() {
        this.visible = false
        this.destroyBeginnerHintView()
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        this.setShouldRevealButton(data, HiddenUIElement.Trade, GameAction.CreateTrade)
        this.stateUpdated()

        const isTradeAction = this.beginnerModeActionType == GameAction.CreateTrade
        isTradeAction ? this.setUpdateAction() : this.updateAction(() => new FloatingText({key: 'strings:game.errors.finishCurrentAction'}, this))
    }
}
